import React from 'react';
import PropTypes from 'prop-types';

export default function ViewDetailsButton(props) {
    const { name } = props;

    return (
        <button
            type="button"
            title={`View details for ${name || 'application'}`}
            className="sg-button-primary appActions-learn"
        >
            View details
        </button>
    );
}
ViewDetailsButton.propTypes = {
    name: PropTypes.string,
};
